/* =========================================================================
   Circulation Check quiz – page "bp-circulation-qz-red"
   Vanilla JS, no dependencies. All content comes from the section JSON
   (data-cq-data="…") rendered by the theme editor settings.
   ========================================================================= */
(function () {
  'use strict';

  var DESKTOP_MQ = window.matchMedia('(min-width: 1024px)');
  var LETTERS = ['A', 'B', 'C', 'D'];
  var TYPE_KEYS = ['open', 'slowing', 'constricted'];

  var app = null;
  var cfg = null;
  var state = { screen: 'intro', q: 0, answers: [] };
  var timers = [];
  var observer = null;
  var result = null;

  /* ---------- helpers ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function setText(sel, text) { $$(sel, app).forEach(function (el) { el.textContent = text == null ? '' : String(text); }); }
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function clearTimers() { timers.forEach(clearTimeout); timers = []; }
  function later(fn, ms) { timers.push(setTimeout(fn, ms)); }
  function num(v, fallback) { var n = Number(v); return isFinite(n) ? n : fallback; }

  function readJSON(key) {
    var el = $('[data-cq-data="' + key + '"]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); }
    catch (e) { console.warn('[circulation-quiz] Could not read ' + key + ' data', e); return null; }
  }

  function track(name, data) {
    data = data || {};
    try { if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: name }, data)); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data); } catch (e) {}
  }

  /* ---------- config ---------- */
  function loadConfig() {
    var qd = readJSON('questions') || { settings: {}, questions: [] };
    var rd = readJSON('results') || { settings: {}, cta: {}, types: {}, pillars: {} };
    var ad = readJSON('analyzing') || {};
    var qs = qd.settings || {};
    var rs = rd.settings || {};

    var questions = (qd.questions || []).map(function (q) {
      var answers = (q.answers || [])
        .map(function (a) { return { text: (a.text || '').trim(), points: num(a.points, 0) }; })
        .filter(function (a) { return a.text !== ''; })
        .map(function (a, i) { a.letter = LETTERS[i] || String(i + 1); return a; });
      return { id: q.id, pillar: q.pillar || 'pressure', text: q.text || '', helper: q.helper || '', answers: answers };
    }).filter(function (q) { return q.text && q.answers.length; });

    // Topic order = order of first appearance in the questions
    var pillarOrder = [];
    questions.forEach(function (q) { if (pillarOrder.indexOf(q.pillar) === -1) pillarOrder.push(q.pillar); });

    return {
      questions: questions,
      pillarOrder: pillarOrder,
      pillarNames: qs.pillarNames || {},
      status: qs.status || {},
      autoAdvance: num(qs.autoAdvance, 320),
      counterMobile: qs.counterMobile || '[n] / [total]',
      counterDesktop: qs.counterDesktop || 'Question [n] / [total]',
      analyzingMs: num(ad.duration, 1900),
      lowestScore: num(rs.lowestScore, 15),
      openMin: num(rs.openMin, 75),
      slowingMin: num(rs.slowingMin, 50),
      moderateFrom: num(rs.moderateFrom, 34),
      highFrom: num(rs.highFrom, 67),
      needLabels: rs.needLabels || ['Low need', 'Moderate need', 'High need'],
      needColors: rs.needColors || ['#2f7a64', '#9a5208', '#b3202c'],
      announce: rs.announce || '',
      types: rd.types || {},
      pillars: rd.pillars || {},
      cta: rd.cta || {}
    };
  }

  /* ---------- scoring ---------- */
  function maxPoints(q) {
    return q.answers.reduce(function (m, a) { return Math.max(m, a.points); }, 0);
  }

  // Score over all questions (results) or only the answered ones (live vessel)
  function computeScore(answers, answeredOnly) {
    var earned = 0, max = 0, answered = 0, pill = {};
    cfg.questions.forEach(function (q, i) {
      var a = answers[i];
      var has = a !== undefined && a !== null && q.answers[a];
      if (answeredOnly && !has) return;
      var qMax = maxPoints(q);
      var p = pill[q.pillar] || (pill[q.pillar] = { earned: 0, max: 0 });
      max += qMax; p.max += qMax;
      if (has) { earned += q.answers[a].points; p.earned += q.answers[a].points; answered++; }
    });
    var range = 100 - cfg.lowestScore;
    var score = max > 0 ? Math.round(100 - (earned / max) * range) : 100;
    var type = score >= cfg.openMin ? 'open' : score >= cfg.slowingMin ? 'slowing' : 'constricted';
    return { earned: earned, max: max, answered: answered, score: score, type: type, pillars: pill };
  }

  function needLevel(p) {
    var pct = p && p.max > 0 ? (p.earned / p.max) * 100 : 0;
    return pct >= cfg.highFrom ? 2 : pct >= cfg.moderateFrom ? 1 : 0;
  }

  /* ---------- screens ---------- */
  function setScreen(name, opts) {
    opts = opts || {};
    state.screen = name;
    app.setAttribute('data-screen', name);
    $$('[data-cq-screen]', app).forEach(function (el) {
      var on = el.getAttribute('data-cq-screen') === name;
      el.hidden = !on;
      el.classList.toggle('is-active', on);
      var wrap = el.closest('.shopify-section') || el;
      wrap.classList.toggle('cq-grow', on);
    });
    if (!opts.keepScroll) window.scrollTo(0, 0);
  }

  function start() {
    clearTimers();
    state.q = 0; state.answers = [];
    hideSticky();
    setScreen('quiz');
    renderQuestion(true);
    track('quiz_start', {});
  }

  function retake() {
    clearTimers();
    state.q = 0; state.answers = [];
    result = null;
    hideSticky();
    setScreen('intro');
  }

  function back() {
    clearTimers();
    if (state.q > 0) { state.q--; renderQuestion(true); }
    else { setScreen('intro'); }
  }

  function pick(index) {
    var q = cfg.questions[state.q];
    if (!q || !q.answers[index]) return;
    clearTimers();
    state.answers[state.q] = index;
    renderAnswers();
    renderLive();
    track('question_answered', { question_number: state.q + 1, answer_letter: q.answers[index].letter, points: q.answers[index].points });

    var current = state.q;
    later(function () {
      if (current < cfg.questions.length - 1) {
        state.q = current + 1;
        renderQuestion(true);
      } else {
        setScreen('analyzing');
        later(showResults, cfg.analyzingMs);
      }
    }, cfg.autoAdvance);
  }

  /* ---------- question rendering ---------- */
  function renderQuestion(focus) {
    var total = cfg.questions.length;
    var q = cfg.questions[state.q];
    if (!q) return;
    var n = pad(state.q + 1), t = pad(total);
    var desktop = DESKTOP_MQ.matches;

    setText('[data-cq-counter]', (desktop ? cfg.counterDesktop : cfg.counterMobile).replace('[n]', n).replace('[total]', t));
    setText('[data-cq-pillar]', cfg.pillarNames[q.pillar] || '');
    setText('[data-cq-qtext]', q.text);
    setText('[data-cq-qhelper]', q.helper);

    var bar = $('[data-cq-progress]', app);
    if (bar) {
      bar.style.gridTemplateColumns = 'repeat(' + total + ', minmax(0, 1fr))';
      bar.innerHTML = '';
      for (var i = 0; i < total; i++) {
        var seg = document.createElement('span');
        if (i <= state.q) seg.className = 'is-on';
        bar.appendChild(seg);
      }
    }

    renderAnswers();
    renderLive();
    renderSteps();

    if (focus) {
      var h = $('[data-cq-qtext]', app);
      if (h) { try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
    }
  }

  function renderAnswers() {
    var wrap = $('[data-cq-answers]', app);
    var q = cfg.questions[state.q];
    if (!wrap || !q) return;
    wrap.innerHTML = '';
    q.answers.forEach(function (a, i) {
      var selected = state.answers[state.q] === i;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cq-answer';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', selected ? 'true' : 'false');
      btn.setAttribute('data-cq-answer', String(i));
      var letter = document.createElement('span');
      letter.className = 'cq-answer__letter';
      letter.setAttribute('aria-hidden', 'true');
      letter.textContent = a.letter;
      var label = document.createElement('span');
      label.textContent = a.text;
      btn.appendChild(letter);
      btn.appendChild(label);
      wrap.appendChild(btn);
    });
  }

  function renderLive() {
    var screen = $('[data-cq-screen="quiz"]', app);
    if (!screen) return;
    var r = computeScore(state.answers, true);
    var live = r.answered ? r.score : 100;
    screen.style.setProperty('--cq-live', live);
    var s = cfg.status;
    var label, color;
    if (!r.answered) { label = s.wideOpen; color = 'var(--cq-text)'; }
    else if (live >= cfg.openMin) { label = s.open; color = cfg.needColors[0]; }
    else if (live >= cfg.slowingMin) { label = s.narrowing; color = cfg.needColors[1]; }
    else { label = s.tight; color = cfg.needColors[2]; }
    $$('[data-cq-live-status]', app).forEach(function (el) { el.textContent = label || ''; el.style.color = color; });
  }

  function renderSteps() {
    var list = $('[data-cq-steps]', app);
    if (!list) return;
    var current = cfg.questions[state.q] ? cfg.questions[state.q].pillar : null;
    var curIdx = cfg.pillarOrder.indexOf(current);
    list.innerHTML = '';
    cfg.pillarOrder.forEach(function (key, i) {
      var first = -1, last = -1;
      cfg.questions.forEach(function (q, j) { if (q.pillar === key) { if (first < 0) first = j; last = j; } });
      var li = document.createElement('li');
      li.className = 'cq-step' + (i < curIdx ? ' is-done' : i === curIdx ? ' is-current' : '');
      var dot = document.createElement('span'); dot.className = 'cq-step__dot';
      var name = document.createElement('span'); name.textContent = cfg.pillarNames[key] || key;
      var range = document.createElement('span'); range.className = 'cq-step__range';
      range.textContent = first === last ? 'Q' + (first + 1) : 'Q' + (first + 1) + '–' + (last + 1);
      li.appendChild(dot); li.appendChild(name); li.appendChild(range);
      list.appendChild(li);
    });
  }

  /* ---------- results ---------- */
  function showResults() {
    renderResults(state.answers);
    setScreen('results');
    setupSticky();
    track('quiz_complete', { result_type: result.type, score: result.score });
    var h = $('[data-cq-type-name]', app);
    if (h) { try { h.focus({ preventScroll: true }); } catch (e) {} }
  }

  function renderResults(answers) {
    result = computeScore(answers, false);
    var type = cfg.types[result.type] || {};
    var screen = $('[data-cq-screen="results"]', app);
    if (screen) screen.style.setProperty('--cq-score', result.score);

    $$('[data-cq-type-name]', app).forEach(function (el) {
      el.textContent = type.name || '';
      el.style.color = type.color || '';
    });
    setText('[data-cq-type-desc]', type.description || '');
    setText('[data-cq-score]', result.score);
    setText('[data-cq-you-caption]', type.caption || '');
    $$('[data-cq-marker]', app).forEach(function (el) {
      el.style.left = Math.min(98, Math.max(2, result.score)) + '%';
    });

    var grid = $('[data-cq-findings]', app);
    if (grid) {
      grid.innerHTML = '';
      cfg.pillarOrder.forEach(function (key) {
        var lvl = needLevel(result.pillars[key]);
        var notes = (cfg.pillars[key] && cfg.pillars[key].notes) || [];
        var card = document.createElement('div'); card.className = 'cq-finding';
        var top = document.createElement('div'); top.className = 'cq-finding__top';
        var name = document.createElement('span'); name.className = 'cq-finding__name'; name.textContent = cfg.pillarNames[key] || key;
        var badge = document.createElement('span'); badge.className = 'cq-finding__badge';
        badge.textContent = cfg.needLabels[lvl] || ''; badge.style.background = cfg.needColors[lvl] || '';
        var note = document.createElement('p'); note.className = 'cq-finding__note'; note.textContent = notes[lvl] || '';
        top.appendChild(name); top.appendChild(badge);
        card.appendChild(top); card.appendChild(note);
        grid.appendChild(card);
      });
    }

    $$('[data-cq-cta]', app).forEach(function (a) { a.href = ctaHref(result); });

    var live = $('[data-cq-announce]', app);
    if (live && cfg.announce) {
      live.textContent = cfg.announce.replace('[type]', type.name || '').replace('[score]', result.score);
    }
  }

  function ctaHref(r) {
    var base = cfg.cta.url || '#';
    if (!cfg.cta.passResult || base === '#' || !r) return base;
    try {
      var u = new URL(base, window.location.origin);
      u.searchParams.set(cfg.cta.paramType || 'quiz_type', r.type);
      u.searchParams.set(cfg.cta.paramScore || 'quiz_score', String(r.score));
      return u.origin === window.location.origin ? u.pathname + u.search + u.hash : u.toString();
    } catch (e) { return base; }
  }

  /* ---------- mobile sticky CTA ---------- */
  function hideSticky() {
    if (observer) { observer.disconnect(); observer = null; }
    var bar = $('[data-cq-sticky]', app);
    if (bar) bar.classList.remove('is-visible');
  }

  function showSticky() {
    var bar = $('[data-cq-sticky]', app);
    if (bar) bar.classList.add('is-visible');
    if (observer) { observer.disconnect(); observer = null; }
  }

  function setupSticky() {
    hideSticky();
    var sentinel = $('[data-cq-sentinel]', app);
    if (!sentinel) return;
    var offset = num(cfg.cta.triggerOffset, 130);
    if (!('IntersectionObserver' in window)) { showSticky(); return; }
    // Visible once the bottom of "Inside your vessels" rises above (screen bottom − offset)
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var line = (entry.rootBounds ? entry.rootBounds.bottom : window.innerHeight);
        if (entry.isIntersecting || entry.boundingClientRect.top < line) showSticky();
      });
    }, { rootMargin: '0px 0px -' + offset + 'px 0px', threshold: 0 });
    observer.observe(sentinel);
  }

  /* ---------- desktop logo in the question panel ---------- */
  function cloneLogo() {
    var src = $('[data-cq-logo]', app);
    $$('[data-cq-logo-slot]', app).forEach(function (slot) {
      slot.innerHTML = '';
      if (src) {
        var copy = src.cloneNode(true);
        copy.removeAttribute('data-cq-logo');
        slot.appendChild(copy);
      }
    });
  }

  /* ---------- theme editor ---------- */
  function demoAnswers() {
    // Mid-to-high answers so the editor preview shows a realistic result
    return cfg.questions.map(function (q) {
      var target = 2, best = 0, bestDiff = Infinity;
      q.answers.forEach(function (a, i) { var d = Math.abs(a.points - target); if (d < bestDiff) { bestDiff = d; best = i; } });
      return best;
    });
  }

  function previewSection(sectionEl, blockId) {
    if (!sectionEl) return;
    var screenEl = $('[data-cq-screen]', sectionEl);
    var name = screenEl ? screenEl.getAttribute('data-cq-screen') : null;
    clearTimers();
    if (name === 'quiz') {
      var idx = 0;
      if (blockId) cfg.questions.forEach(function (q, i) { if (q.id === blockId) idx = i; });
      state.q = idx;
      setScreen('quiz', { keepScroll: true });
      renderQuestion(false);
    } else if (name === 'results') {
      if (!state.answers.length || state.answers.length < cfg.questions.length) state.answers = demoAnswers();
      renderResults(state.answers);
      setScreen('results', { keepScroll: true });
      showSticky();
    } else if (name) {
      setScreen(name, { keepScroll: true });
    }
  }

  function bindEditor() {
    if (!window.Shopify || !Shopify.designMode) return;
    document.addEventListener('shopify:section:load', function () { init(true); });
    document.addEventListener('shopify:section:select', function (e) { previewSection(e.target, null); });
    document.addEventListener('shopify:block:select', function (e) {
      var section = e.target.closest('.shopify-section');
      previewSection(section, e.detail && e.detail.blockId);
    });
  }

  /* ---------- events ---------- */
  function onClick(e) {
    var answer = e.target.closest('[data-cq-answer]');
    if (answer && app.contains(answer)) { pick(parseInt(answer.getAttribute('data-cq-answer'), 10)); return; }
    var action = e.target.closest('[data-cq-action]');
    if (action && app.contains(action)) {
      var a = action.getAttribute('data-cq-action');
      if (a === 'start') start();
      else if (a === 'back') back();
      else if (a === 'retake') retake();
      return;
    }
    var cta = e.target.closest('[data-cq-cta]');
    if (cta && result) track('cta_click', { result_type: result.type, score: result.score });
  }

  // Arrow keys move between answers (radio group behaviour)
  function onKeydown(e) {
    var btn = e.target.closest && e.target.closest('[data-cq-answer]');
    if (!btn) return;
    var keys = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 };
    if (!(e.key in keys)) return;
    e.preventDefault();
    var all = $$('[data-cq-answer]', app);
    var i = all.indexOf(btn);
    var next = all[(i + keys[e.key] + all.length) % all.length];
    if (next) next.focus();
  }

  /* ---------- init ---------- */
  var bound = false;
  function init(reload) {
    app = document.getElementById('cq-app');
    if (!app) return;
    cfg = loadConfig();
    cloneLogo();
    if (!bound) {
      document.addEventListener('click', onClick);
      document.addEventListener('keydown', onKeydown);
      var onChange = function () { if (state.screen === 'quiz') renderQuestion(false); };
      if (DESKTOP_MQ.addEventListener) DESKTOP_MQ.addEventListener('change', onChange);
      else if (DESKTOP_MQ.addListener) DESKTOP_MQ.addListener(onChange);
      bindEditor();
      bound = true;
    }
    if (reload) {
      // Theme editor reloaded a section: keep the current screen, refresh its content
      if (state.q >= cfg.questions.length) state.q = Math.max(0, cfg.questions.length - 1);
      setScreen(state.screen, { keepScroll: true });
      if (state.screen === 'quiz') renderQuestion(false);
      if (state.screen === 'results') { renderResults(state.answers.length ? state.answers : demoAnswers()); showSticky(); }
    } else {
      setScreen('intro', { keepScroll: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(false); });
  else init(false);

  // Exposed for QA in the browser console: CirculationQuiz.score([3,2,2,3,2,3,2,2])
  window.CirculationQuiz = {
    score: function (answers) { return computeScore(answers || [], false); },
    state: function () { return JSON.parse(JSON.stringify(state)); }
  };
})();
